import { ReactComponent as NoResultsIllustration } from "./svg/noResults.svg";

type Props = {
  width?: string;
  height?: string;
};

export const IconNoResults = ({ width = "10.0625rem", height = "7.5rem" }: Props) => (
  <NoResultsIllustration aria-hidden="true" style={{ width, height }} />
);
